import React from "react";
import { useLang } from "../../lib/LanguageContext";
import { Eye, Compass } from "lucide-react";

export default function VisionMission() {
    const { t } = useLang();
    return (
        <section
            id="vision"
            className="relative py-20 sm:py-24 md:py-32 border-t border-[color:var(--sau-border)] overflow-hidden"
            data-testid="sau-vision-mission"
        >
            <div
                className="absolute inset-0 pointer-events-none opacity-60"
                style={{
                    background:
                        "radial-gradient(700px 300px at 20% 30%, rgba(102, 227, 255, 0.07), transparent 60%), radial-gradient(600px 260px at 80% 70%, rgba(139, 233, 255, 0.05), transparent 60%)",
                }}
                aria-hidden
            />
            <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5">
                    <div className="sau-reveal sau-gradient-border p-[1px] rounded-3xl">
                        <div className="rounded-3xl bg-[#0A1726] p-7 sm:p-8 md:p-10 h-full">
                            <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.28em] text-[color:var(--sau-muted)]">
                                <Eye className="w-4 h-4 text-[color:var(--sau-accent)]" />
                                {t.vision.eyebrow}
                            </div>
                            <h3
                                className="mt-5 text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight"
                                style={{ letterSpacing: "-0.015em" }}
                            >
                                {t.vision.title}
                            </h3>
                            <p className="mt-5 sm:mt-6 text-[15px] sm:text-base md:text-lg text-[color:var(--sau-text-2)] leading-relaxed">
                                {t.vision.body}
                            </p>
                        </div>
                    </div>
                    <div className="sau-reveal sau-gradient-border p-[1px] rounded-3xl">
                        <div className="rounded-3xl bg-[#0A1726] p-7 sm:p-8 md:p-10 h-full">
                            <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.28em] text-[color:var(--sau-muted)]">
                                <Compass className="w-4 h-4 text-[color:var(--sau-accent)]" />
                                {t.mission.eyebrow}
                            </div>
                            <h3
                                className="mt-5 text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight"
                                style={{ letterSpacing: "-0.015em" }}
                            >
                                {t.mission.title}
                            </h3>
                            <p className="mt-5 sm:mt-6 text-[15px] sm:text-base md:text-lg text-[color:var(--sau-text-2)] leading-relaxed">
                                {t.mission.body}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
